import type { ApiError } from "./errors";

type Listener = (e: ApiError) => void;
const listeners = new Set<Listener>();

/** Bridges API client failures to UI (toasts, re-login) without coupling the client to React. */
export const apiErrorBus = {
  emit(e: ApiError) {
    for (const l of listeners) l(e);
  },
  subscribe(l: Listener) {
    listeners.add(l);
    return () => {
      listeners.delete(l);
    };
  },
};
